// extracted by mini-css-extract-plugin
module.exports = {"animalActivity":"filtersBoAnimalActivity_animalActivity__3GI6C","tagNumber":"filtersBoAnimalActivity_tagNumber__2R-fl","submitButton":"filtersBoAnimalActivity_submitButton__3LCuj"};